import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@infra/auth/auth.service';
import { ServicoExecutadoModel } from '@data/servico-executado/models';
import { ServicoExecutadoRepository } from '@data/servico-executado/servico-executado.repository';
import { Campo, FormComponent } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';
import { currencyBRL } from '@shared/formatters';

@Component({
  selector: 'app-detalhes-servico-executado',
  templateUrl: './detalhes-servico-executado.component.html',
  styleUrls: ['./detalhes-servico-executado.component.scss'],
})
export class DetalhesServicoExecutadoComponent implements AfterContentChecked {

  protected situacao: 'Aprovada' | 'Em análise' | 'Reprovada' = 'Em análise';

  protected camposDadosDetalhes: Campo[] = [
    {
      name: '',
      label: 'Autorização para ressarcimento',
      type: 'separator',
    },
    {
      name: 'cliente',
      label: 'Cliente',
      type: 'text',
      disabled: true,
      width: '100%',
    },
    {
      name: 'numeroOrdemServico',
      label: 'Nº OS',
      type: 'text',
      disabled: true,
      width: '20%',
    },
    {
      name: 'placa',
      label: 'Placa',
      type: 'text',
      disabled: true,
      width: '30%',
    },
    {
      name: 'modelo',
      label: 'Modelo',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'km',
      label: 'Odômetro',
      type: 'text',
      disabled: true,
      width: '30%',
    },
    {
      name: 'dataAbertura',
      label: 'Data de abertura',
      type: 'date',
      disabled: true,
      width: '40%',
    },
    {
      name: 'totalReembolsado',
      label: 'Total reembolsado',
      type: 'money',
      disabled: true,
      width: '30%',
      moneyOptions: { 
        prefix: 'R$ ', 
        thousands: '.', 
        decimal: ',', 
        align: 'left', 
        allowNegative: false 
      }
    },
    {
      name: '',
      label: 'Itens da Ordem de Serviço',
      type: 'separator',
    },
    {
      name: 'itens',
      label: 'Itens',
      type: 'table',
      disabled: true,
      width: '100%',
      tableOptions: {
        items: [],
        colunas: [
          {
            name: 'descricao',
            label: 'Descrição',
          },
          {
            name: 'quantidade',
            label: 'Quantidade',
          },
          {
            name: 'valorItem',
            label: 'Valor',
            format: currencyBRL,
          },
          {
            name: 'tipoItem',
            label: 'Tipo',
          },
          {
            name: 'grupoEconomico',
            label: 'Grupo Despesa',
          },
        ]
      }
    },
    {
      name: '',
      label: 'Observações',
      type: 'separator',
    },
    {
      name: 'observacoes',
      label: 'Observações',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
  ];

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: string },
    private dialogRef: MatDialogRef<DetalhesServicoExecutadoComponent>,
    private changeDetector: ChangeDetectorRef,
    private servicoExecutadoRepository: ServicoExecutadoRepository,
    protected authService: AuthService,
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.servicoExecutadoRepository
      .getByIdRequest<{ data: ServicoExecutadoModel }>(this.data.id)
      .subscribe(({ data }) => {
        if (data) {
          this.situacao = data.situacao;
          this.formDetalhes?.load(data);
        }
      });
  }

  protected onSubmit(value: 'A' | 'R') {
    this.servicoExecutadoRepository.putAprovacao({
      codigoOrdemServico: this.data.id,
      statusAprovacao: value,
    }).subscribe({
      next: () => {
        modal.fire({
          title: 'Sucesso!',
          text: `Serviço executado ${value === "A" ? "aprovado" : "reprovado"} com sucesso`,
          icon: 'success',
          confirmButtonText: 'Continuar',
        });

        this.dialogRef.close(true);
      },
      error: () => {
        modal.fire({
          icon: 'error',
          title: `Erro ao ${value === "A" ? "aprovar" : "reprovar"} o serviço executado`,
          html: 'Tente novamente mais tarde',
        });

        this.dialogRef.close(false);
      },
    });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }
}
